import React from 'react';
import PropTypes from 'prop-types';

import { TextInputSto } from '../sto';

const verificationError = 'pages.verificationCode.error';

function VerificationCode(props) {
    const onChange = (event) => {
        const value = event.target.value.replace(/\D/g, '');
        const isValidCodelength = value.length === 6;
        const isValid = value.length < 6 && props.field.isValid === null ? null : isValidCodelength;
        const errorMessage = isValid === false ? verificationError : null;
        props.onChange({ errorMessage, isValid, value });
    };

    const onBlur = () => {
        const isValid = props.field.value.length === 6;
        const errorMessage = !isValid ? verificationError : null;

        props.onBlur({ errorMessage, isValid, value: props.field.value });
    };

    return (
        <React.Fragment>
            <TextInputSto
                errorMessage="pages.verificationCode.error"
                isValid={props.field.isValid}
                label="pages.verificationCode.field"
                maxLength={6}
                name="verificationCode"
                onBlur={onBlur}
                onChange={onChange}
                placeholder="pages.verificationCode.placeholder"
                type="tel"
                value={props.field.value}
            />
        </React.Fragment>
    );
}

VerificationCode.propTypes = {
    field: PropTypes.shape({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default VerificationCode;
